import { StatusTagProps } from "./statutsTagProps";

export const statusColors: Record<StatusTagProps["status"], string> = {
  new: "#ff9800",
  open: "#BF5000",
  pending: "#1f73b7",
  awaiting: "#1c2227",
  solved: "#969696",
  closed: "#666666",
};

export const statusTitles: Record<StatusTagProps["status"], string> = {
  new: "Novo",
  open: "Aberto",
  pending: "Pendente",
  awaiting: "Em espera",
  solved: "Resolvido",
  closed: "Fechado",
};
